import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

new Swiper('[data-role=products]', {
	modules: [Navigation],
	slidesPerView: 1.47,
	spaceBetween: '20px',
	breakpoints: {
		768: {
	        slidesPerView: 2.2,
			spaceBetween: '23px',
		},
		1280: {
	        slidesPerView: 4,
			spaceBetween: '23px',
		}
	},
	navigation: {
		nextEl: '[data-role=next-button]',
		prevEl: '[data-role=prev-button]',
	}
});

const $routineSlider = document.querySelectorAll('[data-role=routine-row]');

$routineSlider.forEach(($el) => {
	new Swiper($el as HTMLElement, {
		modules: [Navigation],
		slidesPerView: 1.1,
		spaceBetween: '0',
		breakpoints: {
			768: {
				enabled: false,
			},
		},
		navigation: {
			nextEl: $el.querySelector('[data-role=next-button-routine]') as HTMLElement ?? null,
			prevEl: $el.querySelector('[data-role=prev-button-routine]') as HTMLElement ?? null,
		}
	});
});

const $imagesSlider = document.querySelectorAll('[data-role=images-slider]');
const updateSlideCounter = (swiper: Swiper, $el: HTMLElement) => {
	const currentSlide = swiper.realIndex + 1;
	const $counterElement = $el.querySelector('[data-role=slide-counter]');

	if ($counterElement) {
		$counterElement.innerHTML = `<span class="_current">${currentSlide}</span><span class="_all">/${swiper.slides.length}</span>`;
	}
};

$imagesSlider.forEach(($el) => {
	new Swiper($el as HTMLElement, {
		modules: [Navigation],
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: $el.querySelector('[data-role=next-button]') as HTMLElement ?? null,
			prevEl: $el.querySelector('[data-role=prev-button]') as HTMLElement ?? null,
		},
		on: {
			init: function () {
				updateSlideCounter(this, $el as HTMLElement);
			},
			slideChange: function () {
				updateSlideCounter(this, $el as HTMLElement);
			},
		},
		breakpoints: {
			768: {
				enabled: true
			}
		}
	});
});

